import React, { forwardRef } from 'react';
import {
  ModuleRegistry,
  TextEditorModule,
  SelectEditorModule,
  NumberEditorModule,
  CheckboxEditorModule,
  DateEditorModule,
  LargeTextEditorModule
} from 'ag-grid-community';
import {
  CellSelectionModule,
  IntegratedChartsModule,
  ExcelExportModule
} from 'ag-grid-enterprise';
import { AgChartsEnterpriseModule } from 'ag-charts-enterprise';
import AgGridTable from '../AgGridTable';

// Register additional editor modules required for sales prospects inline editing
ModuleRegistry.registerModules([
  TextEditorModule,
  SelectEditorModule,
  NumberEditorModule,
  CheckboxEditorModule,
  DateEditorModule,
  LargeTextEditorModule,
  CellSelectionModule,
  ExcelExportModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule)
]);

/**
 * Specialized AG Grid table for Sales Prospects with inline editing support
 *
 * This component extends the base AgGridTable and registers additional editor modules
 * required for inline editing functionality (dropdowns, date pickers, number inputs, checkboxes).
 *
 * @param {Object} props - All props are passed through to AgGridTable
 */
const SalesAgGridTable = forwardRef((props, ref) => {
  return <AgGridTable ref={ref} {...props} />;
});

SalesAgGridTable.displayName = 'SalesAgGridTable';

export default SalesAgGridTable;
